import UnassignedRoyaltyFeeForm from './UnassignedRoyaltyFeeForm';

export default UnassignedRoyaltyFeeForm;
